import React, { Component } from "react";
import { observer, inject } from "mobx-react";

@inject("AuthenticationStore")
@observer
export default class PopupProfile extends Component {
  render() {
    const { AuthenticationStore } = this.props;
    return (
      <section id="popup-profile-nav-btn" className="popup-generic-nav-btn">
        <div className="profile-box">
          <div>
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQI12P4zwAAAgEBAKrChTYAAAAASUVORK5CYII="
              alt=""
              className="transparent-img"
            />
            <img
              src={require("../img/icon-profile.svg")}
              alt=""
              className="icon-profile"
            />
          </div>

          <h4>{AuthenticationStore.user.name}</h4>
          <span>{AuthenticationStore.user.cpf}</span>
        </div>

        <button
          onClick={() => AuthenticationStore.logout()}
          className="btn-logout"
        >
          <img src={require("../img/icon-btn-logout.svg")} alt="" />
          Sair
        </button>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PopupProfile.js